<ng-container *ngIf="isRoute !== null && !isRoute">
  <ng-container *ngIf="organisationTypeId == organisationTypeEnum.Customer">
    <job-screen></job-screen>
  </ng-container>

  <ng-container *ngIf="organisationTypeId == organisationTypeEnum.Engineius">
    <app-vme-job-screen
      [organisationTypeId]="organisationTypeId"
      [organisationId]="organisationId"
    ></app-vme-job-screen>
  </ng-container>

  <ng-container *ngIf="organisationTypeId == organisationTypeEnum.Supplier">
    <app-supplier-job-screen [organisationId]="organisationId"></app-supplier-job-screen>
  </ng-container>
</ng-container>

<ng-container
  *ngIf="
    isRoute !== null &&
    isRoute &&
    (organisationTypeId == organisationTypeEnum.Supplier ||
      organisationTypeId == organisationTypeEnum.Engineius)
  "
>
  <job-screen-route-details [organisationId]="organisationId"></job-screen-route-details>
</ng-container>
